import { useQuery } from "@tanstack/react-query";

import useAuth from "@/hooks/stores/useAuth";
import { userService } from "@/services";

export const userQueryKey = "profile";

export const useUser = () => {
  const { isAuthenticated, userId } = useAuth();
  return useQuery({
    queryKey: [userQueryKey, isAuthenticated],
    queryFn: () => userService.getUser(userId),
    enabled: isAuthenticated,
  });
};

export const useGetUserData = () => {
  const { isAuthenticated, userId } = useAuth();
  return useQuery({
    queryKey: ['user', isAuthenticated],
    queryFn: () => userService.getUserData(userId),
    enabled: isAuthenticated,
  });
};
